export const team = [
  {
    name: "Sol Rebagliati",
    role: "Kinesióloga",
    specialties: ["Kinesiología y Fisiatría", "RPG (Reeducación Postural Global)", "Kalmares Active"],
    image: "",
    bio: "Especialista en rehabilitación postural y ejercicio terapéutico.",
    quote: "La postura correcta es la base para una vida sin dolor"
  },
  {
    name: "Gonzalo Frias",
    role: "Kinesiólogo",
    specialties: ["Kinesiología y Fisiatría", "Ondas de Choque", "MEP (Microelectrólisis Percutánea)"],
    image: "",
    bio: "Especializado en tecnologías de vanguardia para rehabilitación.",
    quote: "La tecnología al servicio de tu recuperación"
  },
  {
    name: "Valentina Jakobson",
    role: "Kinesióloga",
    specialties: ["Kinesiología y Fisiatría", "Plantillas Personalizadas", "Terapia con Ventosas"],
    image: "",
    bio: "Especialista en biomecánica y terapias complementarias.",
    quote: "Cada paso cuenta en tu camino hacia el bienestar"
  },
  {
    name: "Ornella Olguin",
    role: "Kinesióloga",
    specialties: ["Kinesiología y Fisiatría", "Presoterapia", "Drenaje Linfático Manual"],
    image: "",
    bio: "Experta en terapias de drenaje y recuperación circulatoria.",
    quote: "El equilibrio interno se refleja en tu salud externa"
  },
  {
    name: "Ayrton Do Santos",
    role: "Kinesiólogo",
    specialties: ["Kinesiología y Fisiatría", "Ondas de Choque", "Masajes Terapéuticos"],
    image: "",
    bio: "Especialista en terapia manual y tecnologías de rehabilitación.",
    quote: "La combinación perfecta entre técnica y sensibilidad"
  },
  {
    name: "Daniela Palacio",
    role: "Kinesióloga",
    specialties: ["Kinesiología y Fisiatría", "ATM (Articulación Temporomandibular)", "RPG (Reeducación Postural Global)"],
    image: "",
    bio: "Especialista en disfunción temporomandibular y postura.",
    quote: "Una sonrisa sin dolor es un derecho, no un privilegio"
  },
  {
    name: "Facundo Alaimo",
    role: "Kinesiólogo",
    specialties: ["Kinesiología y Fisiatría", "RPG (Reeducación Postural Global)", "Kalmares Active"],
    image: "",
    bio: "Especializado en reeducación postural y entrenamiento funcional.",
    quote: "La consciencia corporal transforma el movimiento"
  },
  {
    name: "Ignacio Vila",
    role: "Osteópata",
    specialties: ["Osteopatía", "Terapia con Ventosas", "Masajes Terapéuticos"],
    image: "",
    bio: "Especialista en osteopatía estructural y visceral.",
    quote: "El cuerpo tiene una sabiduría innata para sanarse"
  },
  {
    name: "Lorena Humana",
    role: "Terapeuta",
    specialties: ["Masajes Terapéuticos", "Drenaje Linfático Manual", "Presoterapia"],
    image: "",
    bio: "Experta en terapias manuales y de drenaje.",
    quote: "Las manos sanadoras transmiten energía y alivio"
  },
  {
    name: "Pamela Uzqueda",
    role: "Terapeuta",
    specialties: ["Masajes Terapéuticos", "Drenaje Linfático Manual", "Terapia con Ventosas"],
    image: "",
    bio: "Especialista en terapias manuales integrativas.",
    quote: "Cada sesión es un renacer para tu cuerpo"
  },
  {
    name: "María Rosa Albornoz",
    role: "Terapeuta",
    specialties: ["Masajes Terapéuticos", "Drenaje Linfático Manual", "Terapias Holísticas"],
    image: "",
    bio: "Con más de una década de experiencia en terapias manuales.",
    quote: "La experiencia se siente en cada contacto terapéutico"
  },
  {
    name: "Jackie Arranz",
    role: "Terapeuta holística",
    specialties: ["Terapias Holísticas", "Masajes Terapéuticos", "Terapia con Ventosas"],
    image: "",
    bio: "Especialista en enfoques integrales para el bienestar.",
    quote: "Sanar es reconectar cuerpo, mente y espíritu"
  },
  {
    name: "Ignacio Alfaro",
    role: "Traumatólogo",
    specialties: ["Traumatología", "Ondas de Choque", "MEP (Microelectrólisis Percutánea)"],
    image: "",
    bio: "Especialista en diagnóstico y tratamiento de lesiones deportivas.",
    quote: "Un diagnóstico preciso es el primer paso hacia la recuperación"
  },
  {
    name: "Hernán Quesada",
    role: "Profesor de educación física",
    specialties: ["Kalmares Active (Entrenamiento Personalizado)", "Plantillas Personalizadas"],
    image: "",
    bio: "Especialista en entrenamiento personalizado y readaptación deportiva.",
    quote: "El movimiento inteligente previene y rehabilita"
  },
  {
    name: "Ariana Hermida",
    role: "Recepcionista",
    specialties: ["Atención al Paciente", "Coordinación de Turnos"],
    image: "",
    bio: "Tu primer contacto para una experiencia personalizada.",
    quote: "Una cálida bienvenida es el inicio de tu recuperación"
  },
  {
    name: "Brisa Melo",
    role: "Recepcionista",
    specialties: ["Gestión Administrativa", "Seguimiento de Pacientes"],
    image: "",
    bio: "Especializada en coordinar tu experiencia en el centro.",
    quote: "Cada detalle cuenta en tu camino hacia el bienestar"
  },
  {
    name: "María José Verta",
    role: "Psicóloga",
    specialties: ["Psicología", "Terapias Holísticas"],
    image: "",
    bio: "Especialista en acompañamiento psicológico para procesos de rehabilitación.",
    quote: "La mente sana es el mejor aliado del cuerpo en recuperación"
  },
  {
    name: "Eugenia Castro",
    role: "Nutricionista",
    exp: "7",
    specialties: ["Nutrición", "Plantillas Personalizadas"],
    image: "",
    bio: "Especialista en nutrición para rehabilitación y rendimiento.",
    quote: "Los alimentos son tu mejor medicina preventiva"
  }
];